(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('CareTeam', CareTeam);

    CareTeam.$inject = ['$resource'];

    function CareTeam ($resource) {
        var resourceUrl =  'api/care-teams/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByPatientId': { 'url': 'api/care-teams-by-patient/:id', method: 'GET', isArray: true},
        });
    }
})();
